import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { ArcherElement } from 'react-archer'

import useStyles from '../../styles'

import { ConnectionPoints } from '../'

const EventElement = ({ element }) => {
  const classes = useStyles()

  return (
    <ArcherElement
      key={element.id}
      id={element.id}
      relations={element.relations}
    >
      <Box className={classes.elementBoxPoint}>
        <Typography
          variant="body2"
          className={classes.elementPointLabel}
          style={{
            color: element.textColor || 'black',
            fontWeight: 'bold',
          }}
        >
          {element.name}
        </Typography>
        <Box className={classes.elementPoint} />
        <ConnectionPoints connectionTypes={element.connectionTypes} />
      </Box>
    </ArcherElement>
  )
}

export default EventElement
